/*───────────────────────────────────────────────────────────────────────────
  redirect-after-add.js
  Redirects to /cart the moment ANY network request that adds an item to the
  cart succeeds, regardless of how the theme performs the add-to-cart call.
────────────────────────────────────────────────────────────────────────────*/

/* ---- 1. Patch window.fetch ------------------------------------------------ */
(function patchFetchRedirect() {
  if (!window.fetch) return;                        // very old browser fallback
  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    /* Detect a request to /cart/add that returned a 2xx */
    try {
      const req = args[0];
      const url = (typeof req === 'string' ? req : req.url) || '';
      if (response.ok && url.includes('/cart/add')) {
        window.location.href = '/cart';
      }
    } catch (_) {
      /* ignore parsing errors */
    }

    return response;
  };
})();

/* ---- 2. Patch XMLHttpRequest --------------------------------------------- */
(function patchXHRRedirect() {
  const OriginalXHR = window.XMLHttpRequest;
  if (!OriginalXHR) return;

  function xhrMatchesCartAdd(url) {
    return url && url.includes && url.includes('/cart/add');
  }

  /* Proxy constructor */
  window.XMLHttpRequest = function () {
    const xhr = new OriginalXHR();

    let requestURL = null;
    let requestMethod = 'GET';

    /* Capture open() parameters to inspect later */
    const originalOpen = xhr.open;
    xhr.open = function (method, url, ...rest) {
      requestMethod = (method || 'GET').toUpperCase();
      requestURL = url;
      return originalOpen.call(this, method, url, ...rest);
    };

    /* Listen for completion */
    xhr.addEventListener('load', function () {
      if (
        xhr.status >= 200 &&
        xhr.status < 300 &&
        requestMethod === 'POST' &&
        xhrMatchesCartAdd(requestURL)
      ) {
        window.location.href = '/cart';
      }
    });

    return xhr;
  };

  /* Preserve prototype chain */
  window.XMLHttpRequest.prototype = OriginalXHR.prototype;
})();
